import { toast } from "react-toastify";
import api from "../../api/axiosConfig"

export const login = (email, password) => {
	return async (dispatch) => {
		try {
			dispatch({ type: "LOGIN_REQUEST" });

			const response = await api.post(`/admin/auth/login`, {
				email,
				password,
			});

			console.log(response);

			if (response.status === 200) {
				localStorage.setItem("token", response.data.accessToken);
				dispatch({
					type: "LOGIN_SUCCESS",
					payload: response.data,
				});

				toast.success(`${response?.data?.message}`, {
					position: "top-center",
					autoClose: 1000,
					hideProgressBar: true,
					closeButton: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					theme: "light",
				});

				return Promise.resolve();  // Resolve on success
			} else {
				throw new Error("Invalid credentials");
			}
		} catch (error) {
			console.log(error);
			const errMsg = error.response?.data?.message || "An error occurred";
			dispatch({ type: "LOGIN_FAILURE" });  // Dispatch failure action

			toast.error(`${errMsg}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);  // Reject on failure
		}
	};
};


export const getProfile = (token) => {
	try {

	}
	catch (err) {
		if (err.response.status === "401")
			toast.error(`Session expired, please login again!`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
		console.log(err)
	}
}

export const addClient = (data) => {
	return async (dispatch) => {
		try {
			dispatch({ type: "ADD_CLIENT_REQUEST" })
			const response = await api.post(
				`/admin/clients/addClient`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "ADD_CLIENT",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};


export const getAllClients = (data) => {
	return async (dispatch) => {
		dispatch({ type: "GET_CLIENTS_REQUEST" });

		try {
			dispatch({ type: "GET_CLIENTS_REQUEST" })
			const response = await api.get(
				`/admin/clients/allClients`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_CLIENTS",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			// return Promise.reject(error);
		}
	};
};

export const editClient = (token, data, id) => {
	return async (dispatch) => {

		dispatch({ type: "EDIT_CLIENT_REQUEST" })
		try {

			const response = await api.post(
				`/admin/clients/editClient/${id}`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "EDIT_CLIENT",
				payload: response.data,
			});

			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const getOneClient = (id) => {
	return async (dispatch) => {
		dispatch({ type: "GET_ONE_CLIENT_REQUEST" });
		try {

			const response = await api.get(
				`/admin/clients/${id}`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ONE_CLIENT",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};


export const getAllServices = (token) => async (dispatch) => {
    try {
        const res = await api.get("/admin/services/allServices", {
            headers: { Authorization: `Bearer ${token}` }
        });
        
        // Ensure res.data is the array we saw in your Network tab
        dispatch({ 
            type: "GET_ALL_SERVICES", 
            payload: res.data 
        });
    } catch (err) {
        console.error("Fetch Services Error:", err);
    }
};
export const addService = (data) => {
	return async (dispatch) => {

		dispatch({ type: "ADD_SERVICES_REQUEST" })
		try {

			const response = await api.post(
				`/admin/services/addServices`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "ADD_SERVICES",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};
export const updateServiceById = (id, formData) => async (dispatch) => {
    try {
        const response = await api.put(`/admin/services/update/${id}`, formData);
        
        // response.data is the array [...] seen in your Network tab
        dispatch({
            type: "UPDATE_SERVICE_SUCCESS",
            payload: response.data 
        });
    } catch (error) {
        console.error("Update Action Error:", error);
    }
};
// Delete Service by ID
export const deleteServiceById = (id) => async (dispatch) => {
    try {
        await api.delete(`/admin/services/delete/${id}`);
        dispatch({
            type: "DELETE_SERVICE_SUCCESS",
            payload: id,
        });
        return Promise.resolve();
    } catch (error) {
        return Promise.reject(error);
    }
};
export const addSubClient = (id, data) => {
	return async (dispatch) => {


		try {

			const response = await api.post(
				`/admin/clients/addSubClient/${id}`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "ADD_SUB_CLIENT",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const editSubClient = (data, id) => {
	return async (dispatch) => {


		try {

			const response = await api.post(
				`/admin/clients/editSubClient/${id}`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "EDIT_SUB_CLIENT",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const toggleClient = (id, status) => {
	return async (dispatch) => {

		dispatch({ type: "TOGGLE_CLIENT_REQUEST" });
		try {

			const response = await api.post(
				`/admin/clients/toggleClient/${id}`,
				{ status }
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "TOGGLE_CLIENT",
				payload: { id, status, ...response.data },
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve(response.data);

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const toggleEmployee = (id, status) => {
	return async (dispatch) => {

		dispatch({ type: "TOGGLE_EMPLOYEE_REQUEST" });
		try {

			const response = await api.post(
				`/admin/employees/toggleEmployee/${id}`,
				{ status }
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "TOGGLE_EMPLOYEE",
				payload: { id, status, ...response.data },
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve(response.data);

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};
export const getOneSubClient = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/clients/subClients/${id}`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ONE_SUB_CLIENT",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};



export const addEmployee = (data) => {
	return async (dispatch) => {

		dispatch({ type: "ADD_EMPLOYEE_REQUEST" })
		try {

			const response = await api.post(
				`/admin/employees/addEmployee/`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "ADD_EMPLOYEE",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};


export const getAllEmployees = () => {
	return async (dispatch) => {
		dispatch({ type: "GET_ALL_EMPLOYEES_REQUEST" })

		try {

			const response = await api.get(
				`/admin/employees/allEmployees`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_EMPLOYEES",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			// return Promise.reject(error);
		}
	};
};


export const getOneEmployee = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/employees/${id}`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ONE_EMPLOYEE",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};



export const editEmployee = (data, id) => {
	return async (dispatch) => {

		dispatch({ type: "EDIT_EMPLOYEE_REQUEST" });
		try {

			const response = await api.post(
				`/admin/employees/editEmployee/${id}`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "EDIT_EMPLOYEE",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);

			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);
		}
	};
};


export const getClientTasks = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/tasks/clients/${id}`,
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_CLIENT_TASKS",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {

			if(error.response.status===404){
				dispatch({
				type: "GET_CLIENT_TASKS",
				payload:[],
			});
			}
			console.log(error);
			// dispatch({
			// 	type: "GET_CLIENT_TASKS",
			// 	payload: [
			// 		{
			// 			id: 1,
			// 		},

			// 	],
			// });

			// toast.error(`${error?.response?.data?.message}`, {
			// 	position: "top-center",
			// 	autoClose: 1000,
			// 	hideProgressBar: true,
			// 	closeButton: false,
			// 	closeOnClick: true,
			// 	pauseOnHover: true,
			// 	draggable: true,
			// 	theme: "light",
			// });

			return Promise.reject(error);
		}
	}
}

export const createTask = (data, id) => {
	return async (dispatch) => {
		dispatch({ type: "CREATE_TASK_REQUEST" })
		try {

			const response = await api.post(
				`/admin/tasks/addTask/${id}`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "CREATE_TASK",
				payload: response.data,
			});

			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});


			return Promise.resolve();

		} catch (error) {
			console.log(error);

			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);
		}
	}
}

export const getMemberTasks = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/tasks/assignees/${id}`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_MEMBER_TASKS",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);

			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);
		}
	}
}



export const updateTask = (data, id) => {
	return async (dispatch) => {
		dispatch({ type: "UPDATE_TASK_REQUEST" })
		const config = {
			headers: {
				"Content-Type": "multipart/form-data"
			},
		};
		try {

			const response = await api.post(
				`/admin/tasks/updateTask/${id}`,
				data,
				config
			);

			dispatch({
				type: "UPDATE_TASK",
				payload: response.data,
			});

			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.resolve();
		} catch (error) {
			console.log(error);

			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);
		}
	}
}

export const deleteTask = (id) => {
	return async (dispatch) => {
		dispatch({ type: "DELETE_TASK_REQUEST" });
		try {
			const response = await api.delete(`/admin/tasks/deleteTask/${id}`);
			dispatch({
				type: "DELETE_TASK_SUCCESS",
				payload: id,
			});

			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.resolve();
		} catch (error) {
			console.log(error);

			toast.error(`${error?.response?.data?.message || "Failed to delete task"}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);
		}
	};
};


export const addNotification = (data) => {

	return async (dispatch) => {
		dispatch({ type: "ADD_NOTIFICATION_REQUEST" })
		const config = {
			headers: {
				"Content-Type": "multipart/form-data"
			},
		};
		try {

			const response = await api.post(
				`/admin/notifications/addNotification`,
				data,
				config
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "ADD_NOTIFICATION",
				payload: response.data,
			});

			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});


			return Promise.resolve();

		} catch (error) {
			console.log(error);

			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});

			return Promise.reject(error);
		}
	}
};



export const getNotifications = () => async (dispatch) => {
    dispatch({ type: "GET_NOTIFICATIONS_REQUEST" });
    try {
        // Adding a timestamp ?t= ensures we bypass the 304 cache and get fresh data
        const response = await api.get(`/admin/notifications/getNotifications/Admin?t=${Date.now()}`);
        
        console.log("Data from API:", response.data); // Verify this is an array in console

        dispatch({
            type: "GET_NOTIFICATIONS",
            payload: response.data,
        });
    } catch (error) {
        console.error("Fetch Error:", error.response?.data || error.message);
    }
};
export const toggleNotificationStatus = (id, newStatus) => async (dispatch) => {
    try {
        // Send the ID in the URL and the STATUS in the body
        const response = await api.post(`/admin/notifications/toggleNotificationStatus/${id}`, {
            status: newStatus 
        });

        // Update Redux state so the change is permanent in the store
        dispatch({
            type: "EDIT_NOTIFICATION",
            payload: { notification: response.data.updatedNotification }
        });
    } catch (error) {
        console.error("Toggle Status Error:", error);
    }
};	
export const addAlert = (data) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_ALERT_REQUEST" });

    try {
      const response = await api.post(`/admin/alert/addAlert`, data);

      dispatch({
        type: "ADD_ALERT",
        // Check your backend: it returns 'alert' inside the JSON
        payload: response.data, 
      });

      toast.success(response.data.message || "Alert added successfully");
      return Promise.resolve();
    } catch (error) {
      // CRITICAL: This turns off the loading state on 400/500 errors
      dispatch({ 
        type: "ADD_ALERT_FAILURE", 
        payload: error?.response?.data?.message || "Something went wrong" 
      });

      toast.error(error?.response?.data?.message || "Error adding alert");
      return Promise.reject(error);
    }
  };
};

export const getAllAlerts = () => async (dispatch) => {
    dispatch({ type: "GET_ALERTS_REQUEST" }); // Spinner ON
    try {
        const res = await api.get("/admin/alert/allAlerts");
        dispatch({ type: "GET_ALERTS", payload: res.data }); // Spinner OFF
    } catch (err) {
        dispatch({ type: "GET_ALERTS_FAILURE" }); // Spinner OFF on error
    }
};
// Add this to your redux/actions/authActions.js
export const toggleAlertStatus = (id, status) => async (dispatch) => {
    // If you don't want the big "Loading..." overlay for a simple toggle, 
    // DO NOT dispatch "TOGGLE_ALERT_STATUS" (the request type).
    try {
        const res = await api.post(`/admin/alert/toggleAlertStatus/${id}`, { status });
        dispatch({
            type: "TOGGLE_ALERT_STATUS_SUCCESS", // This sets loading: false
            payload: res.data, 
        });
        toast.success("Status updated!");
    } catch (err) {
        dispatch({ type: "TOGGLE_ALERT_FAILURE" }); // This sets loading: false
        toast.error("Update failed");
    }
};

// Update notification
export const getOneNotification = (id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ONE_NOTIFICATION_REQUEST" });

    const res = await api.get(`/admin/notifications/getOne/${id}`);

    console.log("API RESPONSE (single notification):", res.data);

    dispatch({
      type: "GET_ONE_NOTIFICATION",
      payload: res.data, // MUST be the notification object
    });
  } catch (err) {
    dispatch({
      type: "GET_ONE_NOTIFICATION_FAILURE",
      payload: err.response?.data || err.message,
    });
  }
};

// EDIT NOTIFICATION
export const editNotification = (id, formData) => async (dispatch) => {
  try {
    dispatch({ type: "EDIT_NOTIFICATION_REQUEST" });

    const res = await api.put(
      `/admin/notifications/editNotification/${id}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    // 🔥 THIS IS WHAT YOU WERE MISSING
    dispatch({
      type: "EDIT_NOTIFICATION",
      payload: { notification: res.data },
    });

    return { success: true };
  } catch (err) {
    console.error("Update failed:", err);
    return { success: false };
  }
};

export const deleteNotification = (id) => async (dispatch) => {
    dispatch({ type: "DELETE_NOTIFICATION_REQUEST" });
    try {
        await api.delete(`/admin/notifications/deleteNotification/${id}`);
        dispatch({ type: "DELETE_NOTIFICATION", payload: id });
    } catch (error) {
        console.error("Delete Error:", error);
    }
};
export const deleteAlert = (id) => async (dispatch) => {
    try {
        // Optional: dispatch a REQUEST if you use a global loader
        // dispatch({ type: "DELETE_REQUEST" });

        await api.delete(`/admin/alert/deleteAlert/${id}`);

        dispatch({
            type: "DELETE_ALERT",
            payload: id, // Pass the ID so the reducer knows which one to remove
        });
        
        // toast.success("Alert deleted successfully");
    } catch (err) {
        console.error("Delete Error:", err);
        dispatch({ type: "STOP_LOADING" });
    }
};

export const getAllEvents = (data) => {
	return async (dispatch) => {
		dispatch({ type: "GET_ALL_EVENTS_REQUEST" })

		try {

			const response = await api.get(
				`/admin/events/getAllEvents`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_EVENTS",
				payload: response.data || [],
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			// return Promise.reject(error);
		}
	};
};

export const createEvent = (data) => {
	return async (dispatch) => {
		dispatch({ type: "CREATE_EVENTS_REQUEST" })

		try {

			const response = await api.post(
				`/admin/events/createEvent`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "CREATE_EVENT",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const deleteEvents = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.delete(
				`/admin/events/deleteEvents/${id}`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "DELETE_EVENTS",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const editEvents = (id, data) => {
	return async (dispatch) => {


		try {
			dispatch({ type: "EDIT_EVENTS_REQUEST" })

			const response = await api.post(
				`/admin/events/editEvents/${id}`,
				data
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "EDIT_EVENTS",
				payload: response.data,
			});
			toast.success(`${response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.resolve();

		} catch (error) {
			console.log(error);
			toast.error(`${error?.response?.data?.message}`, {
				position: "top-center",
				autoClose: 1000,
				hideProgressBar: true,
				closeButton: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				theme: "light",
			});
			return Promise.reject(error);
		}
	};
};

export const getOneEvents = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/events/getOne/${id}`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ONE_EVENTS",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};


export const getAllDepartments = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/departments/getDepartments`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_DEPARTMENTS",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};


export const updateServiceStatus = (id, newStatus) => {
    return async (dispatch) => {
        try {
            // Using the 'api' instance ensures the correct base URL is used
            const response = await api.put(
                `/admin/services/update-status/${id}`,
                { status: newStatus }
            );

            // Update local state for immediate UI feedback
            dispatch({
                type: "UPDATE_SERVICE_STATUS_LOCAL",
                payload: { id, status: newStatus }
            });

            return Promise.resolve(response.data);
        } catch (error) {
            console.error("Update Status Error:", error);
            return Promise.reject(error);
        }
    };
};
export const getAllTasks = (id) => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/tasks/allTasks`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_TASKS",
				payload: response.data,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			// return Promise.reject(error);
		}
	};
};

export const getAllMails = () => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/mails/getAllMail`,
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_MAILS",
				payload: response.data.mails,
			});

			return Promise.resolve();

		} catch (error) {
			console.log(error);
			// return Promise.reject(error);
		}
	};
};
/* redux/actions/authActions.js */
export const getMailById = (id) => async (dispatch) => {
  try {
    // 1. M
	// ust use the exact path from step 1 & 2
    // 2. Ensure NO uppercase letters (one-mail, not OneMail)
    const res = await api.get(`/admin/mails/one-mail/${id}`);
    console.log("API raw response:", res.data);

    dispatch({ type: "GET_MAIL_SUCCESS", payload: res.data.mail });
  } catch (error) {
    console.error("API Error:", error.response?.status); // Check if this logs 404
  }
};
export const getAllReports = () => {
	return async (dispatch) => {


		try {

			const response = await api.get(
				`/admin/report/getAllReports`
			);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_REPORTS",
				payload: response.data.allReports || [],
			});

			// return Promise.resolve();
			return response.data.allReports || [];

		} catch (error) {
			console.log(error);
			return Promise.reject(error);
		}
	};
};

export const updateBill = (id, formData) => {
	return async (dispatch) => {

		try {
			const response = await api.post(
				`${process.env.REACT_APP_API_URL}/admin/report/updateBill/${id}`,
				formData
			);

			dispatch({
				type: "UPDATE_BILL_SUCCESS",
				payload: response.data.updatedBill,
			});

			return Promise.resolve();
		} catch (error) {
			console.error(error);

			return Promise.reject(error);
		}
	};
};



export const adminSetting = (currentPassword, newPassword) => {
	return async (dispatch) => {

		try {
			const response = await api.post(
				`${process.env.REACT_APP_API_URL}/admin/auth/adminSetting`,
				{
					currentPassword,
					newPassword,
				}
			);

			dispatch({
				type: "ADMIN_SETTING",
				payload: response.data,
			});

			return Promise.resolve(response.data);
		} catch (error) {
			console.error(error);
			return Promise.reject(error.response?.data?.message || "Password change failed");
		}
	};
};


export const getAllCompliances = () => {
	return async (dispatch) => {

		dispatch({ type: "GET_ALL_COMPLIANCES_REQUEST" });
		try {

			const response = await api.get(`/client/compliances/`);

			// alert(JSON.stringify(response.status))
			dispatch({
				type: "GET_ALL_COMPLIANCES",
				payload: response.data,
			});

			return Promise.resolve();
		} catch (error) {
			console.log(error);
			// return Promise.reject(error);
		}
	};
};
export const getAllEnquiries = () => async (dispatch) => {
    dispatch({ type: "GET_ENQUIRIES_REQUEST" });
    try {
        const response = await api.get(`/admin/enquiries/`);
        // We dispatch response.data.data because your API nests the array there
        dispatch({
            type: "GET_ENQUIRIES", 
            payload: response.data.data || [], 
        });
        return Promise.resolve();
    } catch (error) {
        dispatch({ type: "GET_ENQUIRIES_FAILURE" });
        return Promise.reject(error);
    }
};
export const getOneEnquiry = (id) => async (dispatch) => {
    dispatch({ type: "GET_ONE_ENQUIRY_REQUEST" });
    try {
        const response = await api.get(`/admin/enquiries/${id}`);
        dispatch({ type: "GET_ONE_ENQUIRY", payload: response.data.data });
        return Promise.resolve(response.data.data);
    } catch (error) {
        dispatch({ type: "GET_ONE_ENQUIRY_FAILURE" });
        return Promise.reject(error);
    }
};

// 3. Create a new enquiry (POST /admin/enquiries/)
export const createEnquiry = (data) => async (dispatch) => {
    dispatch({ type: "CREATE_ENQUIRY_REQUEST" });
    try {
        const response = await api.post(`/admin/enquiries/`, data);
        dispatch({
            type: "CREATE_ENQUIRY_SUCCESS",
            payload: response.data,
        });
        //toast.success(response?.data?.message || "Enquiry created successfully");
        return Promise.resolve();
    } catch (error) {
        toast.error(error?.response?.data?.message);
        return Promise.reject(error);
    }
};

// 4. Update an enquiry (PUT /admin/enquiries/:id)
export const updateEnquiry = (id, data) => async (dispatch) => {
    dispatch({ type: "UPDATE_ENQUIRY_REQUEST" });
    try {
        const response = await api.put(`/admin/enquiries/${id}`, data);
        dispatch({
            type: "UPDATE_ENQUIRY_SUCCESS",
            payload: response.data,
        });
        //toast.success(response?.data?.message || "Enquiry updated successfully");
        return Promise.resolve();
    } catch (error) {
        toast.error(error?.response?.data?.message);
        return Promise.reject(error);
    }
};